import '../../styles/AdminSidebar.css'
import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import {
  Badge,
  Col,
  Collapse,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  Input,
  InputGroup,
  InputGroupText,
  Media,
  Nav,
  NavItem,
  NavLink,
  Row,
  UncontrolledDropdown,
} from 'reactstrap'
import { useUser } from 'context/UserContext'

const AdminSidebar : React.FC = () => {
  const { user } = useUser()
  const [totalUsers, setTotalUsers] = useState<number | null>(null)
  const [totalReports, setTotalReports] = useState<number | null>(null)
  const [collapseOpen, setCollapseOpen] = React.useState(false)
  const location = useLocation()
  
  const fetchAdminData = async () => {
    try {
      const token = localStorage.getItem('token')
      const headers : Record<string, string> = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${ token }`,
      }
      
      const response = await fetch('/api/admin/navbar-data', { headers })
      
      if (!response.ok) {
        throw new Error('Failed to submit report')
      }
      
      if (response.ok) {
        const data = await response.json()
        setTotalUsers(data.totalUsers)
        setTotalReports(data.totalReports)
      } else {
        throw new Error('Failed to fetch navbar data')
      }
    } catch (error) {
      console.error('Error fetching admin data:', error)
    }
  }
  
  useEffect(() => {
    if (user?.roleId === 1) {
      fetchAdminData()
    }
  }, [user])
  
  const activeRoute = (routeName : string) => {
    return location.pathname.indexOf(routeName) > -1 ? 'active': ''
  }
  
  const toggleCollapse = () => {
    setCollapseOpen((data) => !data)
  }
  
  const closeCollapse = () => {
    setCollapseOpen(false)
  }
  
  return (
    <nav id="sidenav-main" className="navbar-vertical fixed-left navbar-light bg-white navbar navbar-expand-md">
      <div className="container-fluid" style={{ minHeight: 'inherit !important'}}>
        <a className="pt-0 mb-0 navbar-brand">
          <img alt="Screen.me"
            className="navbar-brand-img"
            src="/img/icon.png"/>
        </a>
        <Container fluid className="px-0">
          <button className="navbar-toggler" type="button" onClick={ toggleCollapse }>
            <span className="navbar-toggler-icon"/>
          </button>
          <Nav className="align-items-center d-md-none">
            <UncontrolledDropdown nav>
              <DropdownToggle nav className="nav-link-icon">
                <i className="ni ni-bell-55"/>
              </DropdownToggle>
              <DropdownMenu aria-labelledby="navbar-default_dropdown_1" className="dropdown-menu-arrow" right>
                <DropdownItem>Action</DropdownItem>
                <DropdownItem>Another action</DropdownItem>
                <DropdownItem divider/>
                <DropdownItem>Something else here</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown nav>
              <DropdownToggle nav>
                <Media className="align-items-center">
                  <span className="avatar avatar-sm rounded-circle">
                    <img alt="..." src="/img/theme/team-1-800x800.jpg"/>
                  </span>
                </Media>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-arrow" right>
                <DropdownItem className="noti-title" header tag="div">
                  <h6 className="text-overflow m-0">Welcome!</h6>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile">
                  <i className="ni ni-single-02"/>
                  <span>My profile</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile">
                  <i className="ni ni-settings-gear-65"/>
                  <span>Settings</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile">
                  <i className="ni ni-calendar-grid-58"/>
                  <span>Activity</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile">
                  <i className="ni ni-support-16"/>
                  <span>Support</span>
                </DropdownItem>
                <DropdownItem divider/>
                <DropdownItem href="#pablo" onClick={ (e) => e.preventDefault() }>
                  <i className="ni ni-user-run"/>
                  <span>Logout</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
          <Collapse navbar isOpen={ collapseOpen }>
            <div className="navbar-collapse-header d-md-none">
              <Row>
                <Col className="collapse-brand" xs="6">
                  <Link to="/admin">
                    <img alt="ScreenMe" src="/img/icon.png"/>
                  </Link>
                </Col>
                <Col className="collapse-close" xs="6">
                  <button className="navbar-toggler" type="button" onClick={ toggleCollapse }>
                    <span/>
                    <span/>
                  </button>
                </Col>
              </Row>
            </div>
            <Form className="mt-4 mb-3 d-md-none">
              <InputGroup className="input-group-rounded input-group-merge">
                <Input
                  aria-label="Search"
                  className="form-control-rounded form-control-prepended"
                  placeholder="Search"
                  type="search"
                />
                <InputGroupText>
                  <span className="fa fa-search"/>
                </InputGroupText>
              </InputGroup>
            </Form>
            <Nav navbar className="flex-column mt-3">
              <NavItem key="Dashboard">
                <NavLink
                  href="/admin/home"
                  onClick={ closeCollapse }
                  className={ activeRoute('/admin/home') }
                >
                  <i className="ni ni-tv-2 text-primary"/>
                Dashboard
                </NavLink>
              </NavItem>
              <NavItem key="Users">
                <NavLink
                  href="/admin/users"
                  onClick={ closeCollapse }
                  className={ activeRoute('/admin/users') }
                >
                  <i className="fa fa-user-circle-o text-teal"/>
                Users
                  <Badge color="primary" pill className="text-white ml-2">
                    { totalUsers ?? '?' }
                  </Badge>
                </NavLink>
              </NavItem>
              <NavItem key="Users">
                <NavLink
                  href="/admin/reports"
                  onClick={ closeCollapse }
                  className={ activeRoute('/admin/reports') }
                >
                  <i className="fa fa-flag-o text-orange"/>
                Reports
                  <Badge color="warning" pill className="text-white ml-2">
                    { totalReports ?? '?' }
                  </Badge>
                </NavLink>
              </NavItem>
            </Nav>
            <hr className="my-3"/>
            <Nav className="mb-md-3" navbar>
              <NavItem className="active-pro active">
                <NavLink href="/">
                  <i className="ni ni-spaceship"/>
                Go back on Screen.me
                </NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
      </div>
    </nav>
  
  )
}

export default AdminSidebar
